/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
Vue.use(Vuesax)

import vSelect from "vue-select";

Vue.component("v-select", vSelect);

// Theme Configurations
import themeConfig from '../themeConfig.js'

// import axios
import axios from 'axios'
Vue.prototype.$api = axios.create({
  baseURL: themeConfig.apiurl
})

// Mixins
import mixins from './mixins';
Vue.mixin(mixins);

// Algolia - Instant Search
import InstantSearch from 'vue-instantsearch';
Vue.use(InstantSearch);


// VeeValidate
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);

// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css';


// Start Leaflet
// https://tutorials.technology/solved_errors/Vue2Leaflet-vue-marker-not-displaying-on-map-and-map-not-fully-rendering.html
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});
// End Leaflet


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Vue internationalization i18n
import i18n from '@/plugins/i18n';

// google analitics
import VueAnalytics from 'vue-analytics';

// Vue flags
import FlagIcon from 'vue-flag-icon';

// Feather font icon
require('./assets/css/iconfont.css')

Vue.use(FlagIcon);
Vue.config.productionTip = false;

let globalData = new Vue({
  data: {
    $user: JSON.parse(localStorage.getItem('userSession'))
  }
});

Vue.mixin({
    computed: {
      $user: {
          get: function () { return globalData.$data.$user },
          set: function (newVal) {
            globalData.$data.$user = newVal;
          }
      }
  },
  watch: {
      $user: {
          handler: function(new_val, old_val) {
            if (new_val === null) {

                localStorage.removeItem('userSession');

                if (typeof window.removeUserWidgets === 'function') {
                    window.removeUserWidgets();
                    const element = document.querySelector('.uwy.userway_p3 .userway_buttons_wrapper');

                    if (element) {
                        element.style.left = 'calc(100vw - 21px)';
                    }
                }

            } else {

                localStorage.setItem(
                    'userSession',
                    JSON.stringify(new_val)
                );

                if (typeof window.loadUserWidgets === 'function') {
                    window.loadUserWidgets();
                    setTimeout(function () {
                        const element = document.querySelector(
                            '.uwy.userway_p3 .userway_buttons_wrapper'
                        );

                        if (element) {
                            element.style.left = 'calc(100vw - 91px)';
                        }
                    }, 1000);
                }
            }
          },
          deep: true
      },
  },
})

if(process.env.NODE_ENV === 'production') {
  Vue.use(VueAnalytics, {
      id: 'UA-174481442-1',
      router
  });
}

new Vue({
    router,
	  i18n,
    store,
    render: h => h(App)
}).$mount('#app')

